<template>
	<div class="research">
		<leftnav class="fl" mkcode="b" :mktype="'yjbg'" itemcode="A-SCQBDT"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox mt research-rem">
					<dl class="mb-4">
						<dt class="page-title letter-sp">未来5-10年的<b>产业机会</b>在哪里？</dt>
						<dd>过去十年，主要的产业机会是“战略性新兴产业”，也就是2010年国务院提出的节能环保、新一代信息技术、生物、高端装备制造、新能源、新材料、新能源汽车等七大战略性新兴产业。目前，这些产业已经发展壮大，并成为一些城市的主导产业。对于<b>战略性新兴产业</b>，下一步的思路是<b>继续做大做强</b>。
						</dd>
						<dd><b
								class="baseColor-font">那么，未来5-10年的产业机会又在哪里？</b>我们的观点是：<b>当下的机会在过去，新的机会在未来</b>。意思是说，当你看到<b>当下</b>某些产业发展不错，看到有的城市、有的企业抓住这些产业的大机会时，是因为别人在<b>过去</b>几年或十年提前做了布局；而想要抓住<b>新的机会</b>，就要向前看，到<b>未来</b>去找。当看到一个产业现在很火、发展很好，你才开始出手，通常都太晚，已经来不及了。
						</dd>
						<dd>向前看，到未来去找新机会，结论很清楚：<b>未来5-10年的机会，就是在“未来产业”里</b>，也就是今年1月29日《<a
								href="https://www.miit.gov.cn/jgsj/kjs/wjfb/art/2024/art_a9950c3b3cbe47b4b45519ce4a376687.html"
								target="_blank"
								class="curp-a cur baseColor-font">工业和信息化部等七部门关于推动未来产业创新发展的实施意见</a>》提到的“未来产业”。具体地说，
							未来产业包括<b>未来制造、未来信息、未来材料、未来能源、未来空间和未来健康产业</b>六大方向。</dd>
						<dd><b
								class="baseColor-font">当下的“未来产业”，就是十年前“战略性新兴产业”，</b>所以就是代表着今后10年的主要产业机会方向。<b>做大做强战略性新兴产业，提前布局培育未来产业，</b>就是发展<b>新质生产力</b>的产业抓手。
						</dd>
						<dd>以下研究报告，就是针对<b>未来产业的六大方向</b>，深入挖掘各个方向下的重点产业投资机会，并做详细地分析及预测。</dd>
					</dl>
					<div class="flexcss">
						<div class="research-page-left width48PC">
							<table border="0" cellspacing="0" cellpadding="0" class="research_table mb-5"
								v-for="(list, index) in tableList" :key="index">
								<tr>
									<th :style="'backgroundColor:' + table_color[index]">{{ list.name }}</th>
								</tr>
								<tr v-for="(item, i) in list.reportList" :key="i">
									<td>
										<span class="curp-a" @click="routerblank('/reportDetail?id='+item.id)">{{ item.title }}</span>
										</td>
								</tr>
								<tr>
									<td @click="linkReportWeb(list.name)" class="curp-a">更多 >></td>
								</tr>
							</table>
						</div>
						<div class="research-page-right width48PC">
							<div class="mb-3">
								<h3 class="text-center"><a
										href="https://www.miit.gov.cn/jgsj/kjs/wjfb/art/2024/art_a9950c3b3cbe47b4b45519ce4a376687.html"
										target="_blank">工业和信息化部等七部门关于推动未来产业创新发展的实施意见</a><a
										href="https://www.miit.gov.cn/jgsj/kjs/wjfb/art/2024/art_a9950c3b3cbe47b4b45519ce4a376687.html"
										target="_blank" class="baseColor-font-a">查看全文 >></a></h3>
								<p class="text-center">工信部联科〔2024〕12号</p>
							</div>

							<p>各省、自治区、直辖市及计划单列市、新疆生产建设兵团工业和信息化、教育、科技、交通运输、文化和旅游、国有资产监督管理主管部门，中国科学院院属各单位，各省、自治区、直辖市通信管理局，有关中央企业，各有关单位:
							</p>
							<p>未来产业由前沿技术驱动，当前处于孕育萌发阶段或产业化初期，是具有显著战略性、引领性、颠覆性和不确定性的前瞻性新兴产业。大力发展未来产业，是引领科技进步、带动产业升级、培育新质生产力的战略选择。为贯彻落实党的二十大精神和《中华人民共和国国民经济和社会发展第十四个五年规划和2035年远景目标纲要》，把握新一轮科技革命和产业变革机遇，围绕制造业主战场加快发展未来产业，支撑推进新型工业化，现提出如下意见。
							</p>
							<p>一、指导思想 （略）</p>
							<p>二、基本原则（略）</p>
							<p>三、发展目标 （略）</p>
							<p class="mt-2"><b>四、重点任务</b></p>
							<dl class="mb-4">
								<dt>（一）全面布局未来产业</dt>
								<dd>1.加强前瞻谋划部署。把握全球科技创新和产业发展趋势，重点推进未来制造、未来信息、未来材料、未来能源、未来空间和未来健康六大方向产业发展。打造未来产业瞭望站，利用人工智能、先进计算等技术精准识别和培育高潜能未来产业。发挥新型举国体制优势，引导地方结合产业基础和资源禀赋，合理规划、精准培育和错位发展未来产业。发挥前沿技术增量器作用，瞄准高端、智能和绿色等方向，加快传统产业转型升级，为建设现代化产业体系提供新动力。
								</dd>
							</dl>
							<table class="file-table" cellspacing="0" cellpadding="0">
								<tr>
									<th>专栏1：前瞻部署新赛道</th>
								</tr>
								<tr>
									<td><b>未来制造。</b>发展智能制造、生物制造、纳米制造、激光制造、循环制造，突破智能控制、智能传感、模拟仿真等关键核心技术，推广柔性制造、共享制造等模式，推动工业互联网、工业元宇宙等发展。
									</td>
								</tr>
								<tr>
									<td><b>未来信息。</b>推动下一代移动通信、卫星互联网、量子信息等技术产业化应用，加快量子、光子等计算技术创新突破，加速类脑智能、群体智能、大模型等深度赋能，加速培育智能产业。
									</td>
								</tr>
								<tr>
									<td><b>未来材料。</b>推动有色金属、化工、无机非金属等先进基础材料升级，发展高性能碳纤维、先进半导体等关键战略材料，加快超导材料等前沿新材料创新应用。</td>
								</tr>
									<tr>
									<td><b>未来能源。</b>聚焦核能、核聚变、氢能、生物质能等重点领域，打造“采集-存储-运输-应用”全链条的未来能源装备体系。研发新型晶硅太阳能电池、薄膜太阳能电池等高效太阳能电池及相关电子专用设备，加快发展新型储能，推动能源电子产业融合升级。
									</td>
								</tr>
								<tr>
									<td><b>未来空间。</b>聚焦空天、深海、深地等领域，研制载人航天、探月探火、卫星导航、临空无人系统、先进高效航空器等高端装备，加快深海潜水器、深海作业装备、深海搜救探测设备、深海智能无人平台等研制及创新应用，推动深地资源探采、城市地下空间开发利用、极地探测与作业等领域装备研制。
									</td>
								</tr>
								<tr>
									<td><b>未来健康。</b>加快细胞和基因技术、合成生物、生物育种等前沿技术产业化，推动5G/6G、元宇宙、人工智能等技术赋能新型医疗服务，研发融合数字孪生、脑机交互等先进技术的高端医疗装备和健康用品。
									</td>
								</tr>
							</table>
							<p>（二）加快技术创新和产业化 （略）</p>
							<dl class="mb-5">
								<dt>（三）打造标志性产品</dt>
								<dd>4.突破下一代智能终端。发展适应通用智能趋势的工业终端产品，支撑工业生产提质增效，赋能新型工业化。发展量大面广、智能便捷、沉浸体验的消费级终端，满足数字生活、数字文化、公共服务等新需求。打造智能适老的医疗健康终端，提升人民群众生命健康质量。突破高级别智能网联汽车、元宇宙入口等具有爆发潜能的超级终端，构筑产业竞争新优势。
								</dd>
								<dd>5.做优信息服务产品。发展下一代操作系统，构筑安全可靠的数字底座。推广开源技术，建设开源社区，构建开源生态体系。探索以区块链为核心技术、以数据为关键要素，构建下一代互联网创新应用和数字化生态。面向新一代移动信息网络、类脑智能等加快软件产品研发，鼓励新产品示范应用，激发信息服务潜能。
								</dd>
								<dd>6.做强未来高端装备。面向国家重大战略需求和人民美好生活需要，加快实施重大技术装备攻关工程，突破人形机器人、量子计算机、超高速列车、下一代大飞机、绿色智能船舶、无人船艇等高端装备产品，以整机带动新技术产业化落地，打造全球领先的高端装备体系。深入实施产业基础再造工程，补齐基础元器件、基础零部件、基础材料、基础工艺和基础软件等短板，夯实未来产业发展根基。
								</dd>
							</dl>
							<table class="file-table" cellspacing="0" cellpadding="0">
								<tr>
									<th>专栏2：创新标志性产品</th>
								</tr>
								<tr>
									<td><b>人形机器人。</b>突破机器人高转矩密度伺服电机、高动态运动规划与控制、仿生感知与认知、智能灵巧手、电子皮肤等核心技术，重点推进智能制造、家庭服务、特殊环境作业等领域产品的研制及应用。
									</td>
								</tr>
								<tr>
									<td><b>量子计算机。</b>加强可容错通用量子计算技术研发，提升物理硬件指标和算法纠错性能，推动量子软件、量子云平台协同布置，发挥量子计算的优越性，探索向垂直行业应用渗透。
									</td>
								</tr>
								<tr>
									<td><b>新型显示。</b>加快量子点显示、全息显示等研究，突破Micro-LED、激光、印刷等显示技术并实现规模化应用，实现无障碍、全柔性、3D立体等显示效果，加快在智能终端、智能网联汽车、远程连接、文化内容呈现等场景中推广。
									</td>
								</tr>
								<tr>
									<td><b>脑机接口。</b>突破脑机融合、类脑芯片、大脑计算神经模型等关键技术和核心器件，研制一批易用安全的脑机接口产品，鼓励探索在医疗康复、无人驾驶、虚拟现实等典型领域的应用。
									</td>
								</tr>
								<tr>
									<td><b>6G网络设备。</b>开展先进无线通信、新型网络架构、跨域融合、空天地一体、网络与数据安全等技术研究，研制无线关键技术概念样机，形成以全息通信、数字孪生等为代表的特色应用。
									</td>
								</tr>
								<tr>
									<td><b>超大规模新型智算中心。</b>加快突破GPU芯片、集群低时延互连网络、异构资源管理等技术，建设超大规模智算中心，满足大模型迭代训练和应用推理需求。</td>
								</tr>
								<tr>
									<td><b>第三代互联网。</b>推动第三代互联网在数据交易所应用试点，探索利用区块链技术打通重点行业及领域各主体平台数据，研究第三代互联网数字身份认证体系，建立数据治理和交易流通机制，形成可复制可推广的典型案例
									</td>
								</tr>
								<tr>
									<td><b>高端文旅装备。</b>研发支撑文化娱乐创作的专用及配套软件，推进演艺与游乐先进装备、水陆空旅游高端装备、沉浸式体验设施、智慧旅游系统及检测监测平台的研制，发展智能化、高端化、成套化文旅设备。
									</td>
								</tr>
								<tr>
									<td><b>先进高效航空装备。</b>围绕下一代大飞机发展，突破新型布局、智能驾驶、互联航电、多电系统、开式转子混合动力发动机等核心技术。推进超声速、超高效亚声速、新能源客机等先进概念研究。围绕未来智慧空中交通需求，加快电动垂直起降航空器、智能高效航空物流装备等研制及应用。
									</td>
								</tr>
								<tr>
									<td><b>深部资源勘探开发装备。</b>围绕深部作业需求，以超深层智能钻机工程样机、深海油气水下生产系统、深海多金属结核采矿车等高端资源勘探开发装备为牵引，推动一系列关键技术攻关。
									</td>
								</tr>
							</table>
							<p>（四）壮大产业主体 </p>
							<dl>
								<dt></dt>
								<dd>7.培育高水平企业梯队。引导领军企业前瞻谋划新赛道，通过内部创业、投资孵化等培育未来产业新主体。实施中央企业未来产业启航行动计划，加快培育未来产业新企业。建设未来产业创新型中小企业孵化基地，梯度培育专精特新中小企业、高新技术企业和“小巨人”企业。支持新型研发机构快速发展，培育多元化的未来产业推进力量。
								</dd>
								<dd>8.打造特色产业链。依托龙头企业培育未来产业产业链，建设先进技术体系。鼓励有条件的地区先行先试，结合国家自主创新示范区、国家高新技术产业开发区、新型工业化产业示范基地等，创建未来产业先导区，推动产业特色化集聚发展。创新管理机制，建设数字化的供应链产业链，促进创新资源汇聚，加速数据、知识等生产要素高效流通。
								</dd>
								<dd>9.构建产业生态。加强产学研用协作，打造未来产业创新联合体，构建大中小企业融通发展、产业链上下游协同创新的生态体系。强化全国统一大市场下的标准互认和要素互通，提升产业链供应链韧性，构建产品配套、软硬协同的产业生态。
								</dd>
							</dl>



							<p>（五）丰富应用场景（略）</p>
							<p>（六）优化产业支撑体系（略）</p>
							<p>五、保障措施（略）</p>
							<div class="text-right">
								<p>工业和信息化部</p>
								<p>教育部</p>
								<p>科学技术部</p>
								<p>交通运输部</p>
								<p>文化和旅游部</p>
								<p>国务院国有资产监督管理委员会</p>
								<p>中国科学院</p>
								<p class="mt-1">2024年1月18日</p>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import ajaxapi from '../../utils/api';
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'research-index',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			curWebsite: this.$api.getWebsiteType(),
			userdata: {},
			table_color: ['#825900', '#4285c7', '#55596e', '#056435', '#003c64', '#5b6b00', '#850000',],
			tableList: [],
		}
	},
	created() {
		// this.userdata = this.getuseriformation();
	},
	mounted() {
		this.getPageList();
		document.title = "产业研究-产业研究大脑体验版";
	},
	methods: {
		getPageList() {
			var _this = this;
			var ajaxurl = this.$api.free.report.futureIndustry();
			this.bus.$emit('loading', true);
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					_this.tableList = res.data.list;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		linkReportWeb(name) {
			if (name == "未来制造产业") {
				window.open(ajaxapi.getReportListUrl(10014, 10015) + '&token=' + this.userdata.token); //研究报告库外部跳转
			}
			if (name == "未来信息产业") {
				window.open(ajaxapi.getReportListUrl(10005) + '&token=' + this.userdata.token); //研究报告库外部跳转
			}
			if (name == "未来材料产业") {
				window.open(ajaxapi.getReportListUrl(10024, 10027) + '&token=' + this.userdata.token); //研究报告库外部跳转
			}
			if (name == "未来能源产业") {
				window.open(ajaxapi.getReportListUrl(10024, 10044) + '&token=' + this.userdata.token); //研究报告库外部跳转
			}
			if (name == "未来空间产业") {
				window.open(ajaxapi.getReportListUrl(10014, 10016) + '&token=' + this.userdata.token); //研究报告库外部跳转
			}
			if (name == "未来健康产业") {
				window.open(ajaxapi.getReportListUrl(10001) + '&token=' + this.userdata.token); //研究报告库外部跳转
			}
			if (name == "其他未来产业") {
				window.open(ajaxapi.getReportUrl() + '&token=' + this.userdata.token); //研究报告库外部跳转

			}
		},

	},
}
</script>

<style>
.baseColor-font-a {
	color: #5E83CC;
	font-size: 14px;
	display: inline-block;
	font-weight: normal;
}

.baseColor-font {
	color: #065dbb;
}

.width50PC {
	width: 50%;
}

.width48PC {
	width: 48%;
}

.mb-5 {
	margin-bottom: 50px !important;
}

.text-right {
	text-align: right;
}

.text-center {
	text-align: center !important;
}

.letter-sp {
	letter-spacing: 2px;
}

.page-title {
	font-size: 36px;
	color: #d21919;
	margin-bottom: 30px;
	text-align: center;
}

.colord21919 {
	color: #d21919;
}

.research-rem {
	text-indent: 2em;
	line-height: 32px;
	padding: 40px 40px;
}

.mb-4 {
	margin-bottom: 50px;
}

.research-rem dd {
	margin-bottom: 10px;
}

.research_table {
	text-align: center;
	width: 95%;
	margin: 0 auto;
}

.research_table th {
	padding: 6px 20px;
	background: #4285c7;
	font-size: 16px;
	color: #fff;
}

.research_table td {
	font-size: 16px;
	border-bottom: 1px solid #000000;
	min-width: 30px;
	padding: 6px 20px;
}

.file-table {
	border: 1px solid #333;
	margin-bottom: 30px;
}

.file-table th {
	background: #fff;
	border-bottom: 1px solid #333;
	margin-top: 30px;
}

.file-table td {
	padding: 0 20px;
}</style>
